import styled from 'styled-components';
import { Input } from '@bynder/design-system';

export const StyledInput = styled(Input)<{ $isUppercase: boolean }>`
    input {
        text-transform: ${(props) => (props.$isUppercase ? 'uppercase' : 'none')};
    }
`;
